// extracted by mini-css-extract-plugin
export default {"section":"styles_section__+PU0r","img":"styles_img__-FHgy","heading":"styles_heading__-UfZ0","para":"styles_para__rVbgT"};